import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

// Private Routes
import RequireAuth from "./components/RequireAuth"
import Dashboard from './views/Dashboard';

// Public Routes
import LoginPage  from "./views/LoginPage"
import RegisterPage  from "./views/RegisterPage"
import ResetPasswordPage from "./views/ResetPasswordPage"
import SetNewPasswordPage from "./views/SetNewPasswordPage"
// feat/email-change
import ConfirmEmailPage from "./views/ConfirmEmailPage"

function App() {
  return (
        <BrowserRouter>
            <Routes>
                <Route path="/login" element={<LoginPage />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route path="/reset" element={<ResetPasswordPage />} />
                <Route path="/newpassword/:token" element={<SetNewPasswordPage />} />
                {/* feat/email-change — ΛΑ-02 / D45. Δημόσια, χωρίς RequireAuth:
                    ο σύνδεσμος ανοίγει στον περιηγητή όπου διαβάζεται το μήνυμα,
                    που είναι συνήθως άλλος από εκείνον της συνεδρίας. */}
                <Route path="/confirm-email/:token" element={<ConfirmEmailPage />} />
                {/* Το /* παραδίδει το υπόλοιπο της διεύθυνσης στο εσωτερικό Routes του Dashboard */}
                <Route path="/*" element={<RequireAuth><Dashboard /></RequireAuth>} />
            </Routes>
        </BrowserRouter>
  );
}

export default App;
